const EmailLabelSelectOptions = ({ destinations = [] }) => (
  destinations.map(({ key, label }) => (
    <option key={key} value={key}>{label}</option>
  ))
);

export default EmailLabelSelectOptions
